import ButtonWithTooltip from 'common/components/button/withTooltip'
import Chip from 'common/components/Chip'
import { Copy } from 'common/icons'
import { replaceNewLineEmojiAsElement } from 'common/variantsUtils'

type Props = {
  text: string
  isControlVariant: boolean
  onClickCopy: (text: string) => void
}

const VariantCell = ({ text, isControlVariant, onClickCopy }: Props) => {
  return (
    <div className="flex justify-between items-center">
      <span>
        {replaceNewLineEmojiAsElement(text)}
        {isControlVariant && (
          <Chip
            className="ml-6"
            text="Control"
            backgroundColor="bg-orange-500"
          />
        )}
      </span>
      <ButtonWithTooltip
        tooltip={false}
        data-cy="copy-variant"
        title="Copy variant to clipboard"
        className="py-0"
        onClick={() => {
          onClickCopy(text)
        }}
        icon={<Copy />}
      />
    </div>
  )
}

export default VariantCell
